import { render, staticRenderFns } from "./ConnectWoocommerce.vue?vue&type=template&id=f384a35e&lang=html&"
import script from "./ConnectWoocommerce.vue?vue&type=script&lang=js&"
export * from "./ConnectWoocommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports